// Define the Toast types as an enum
export enum ToastType {
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
}
